"use client";

import { c as _c } from "react/compiler-runtime";
import { AuthContext } from "@/components/auth/Auth";
import { ApiNotificationCause } from "@/generated/models/ApiNotificationCause";
import { usePrefetchNotifications } from "@/hooks/useNotificationsQuery";
import { useContext, useLayoutEffect, useRef } from "react";
export interface NotificationFilter {
  cause: ApiNotificationCause[];
  title: string;
}
const NotificationFilters: NotificationFilter[] = [{
  cause: [],
  title: "All"
}, {
  cause: [ApiNotificationCause.IdentityMentioned, ApiNotificationCause.DropQuoted],
  title: "Mentions"
}, {
  cause: [ApiNotificationCause.DropReplied],
  title: "Replies"
}, {
  cause: [ApiNotificationCause.IdentitySubscribed],
  title: "Follows"
}, {
  cause: [ApiNotificationCause.DropVoted, ApiNotificationCause.DropReacted, ApiNotificationCause.DropBoosted],
  title: "Reactions"
}, {
  cause: [ApiNotificationCause.WaveCreated],
  title: "Invites"
}];
export default function NotificationsCauseFilter(t0) {
  const $ = _c(27);
  const {
    activeFilter,
    setActiveFilter
  } = t0;
  const containerRef = useRef(null);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const buttonRefs = useRef(t1);
  const highlightRef = useRef(null);
  const activeIndexRef = useRef(0);
  const {
    connectedProfile
  } = useContext(AuthContext);
  const prefetchNotifications = usePrefetchNotifications();
  let t2;
  if ($[1] !== connectedProfile || $[2] !== prefetchNotifications) {
    t2 = filter => {
      if (!connectedProfile) {
        return;
      }
      prefetchNotifications({
        identity: connectedProfile.handle,
        cause: filter.cause,
        pages: 1
      });
    };
    $[1] = connectedProfile;
    $[2] = prefetchNotifications;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const handleHover = t2;
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = filterIndex => {
      const button = buttonRefs.current[filterIndex];
      const highlight = highlightRef.current;
      if (button && highlight) {
        let l = button.offsetLeft;
        let w = button.offsetWidth;
        if (filterIndex === 0) {
          l = l + 2;
          w = w - 2;
        }
        if (filterIndex === NotificationFilters.length - 1) {
          w = w - 2;
        }
        highlight.style.left = `${l}px`;
        highlight.style.width = `${w}px`;
      }
    };
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const updateHighlightPosition = t3;
  let t4;
  let t5;
  if ($[5] !== activeFilter) {
    t4 = () => {
      const idx = activeFilter == null ? 0 : Math.max(0, NotificationFilters.findIndex(f => f.title === activeFilter.title));
      activeIndexRef.current = idx;
      updateHighlightPosition(idx);
      const container = containerRef.current;
      if (!container) {
        return;
      }
      const ro = new ResizeObserver(() => updateHighlightPosition(activeIndexRef.current));
      ro.observe(container);
      return () => ro.disconnect();
    };
    t5 = [activeFilter];
    $[5] = activeFilter;
    $[6] = t4;
    $[7] = t5;
  } else {
    t4 = $[6];
    t5 = $[7];
  }
  useLayoutEffect(t4, t5);
  let t10;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[8] !== activeFilter || $[9] !== handleHover || $[10] !== setActiveFilter) {
    const handleChange = (filter_0, filterIndex_0) => {
      setActiveFilter(filter_0);
      activeIndexRef.current = filterIndex_0;
      updateHighlightPosition(filterIndex_0);
      const button_0 = buttonRefs.current[filterIndex_0];
      const container_0 = containerRef.current;
      if (button_0 && container_0) {
        const containerWidth = container_0.clientWidth;
        const scrollWidth = container_0.scrollWidth;
        const buttonLeft = button_0.offsetLeft;
        const buttonWidth = button_0.offsetWidth;
        let scrollLeft = buttonLeft - containerWidth / 2 + buttonWidth / 2;
        if (scrollLeft < 0) {
          scrollLeft = 0;
        }
        if (scrollLeft > scrollWidth - containerWidth) {
          scrollLeft = scrollWidth - containerWidth;
        }
        container_0.scrollTo({
          left: scrollLeft,
          behavior: "smooth"
        });
      }
    };
    let t11;
    if ($[16] !== activeFilter) {
      t11 = filter_1 => activeFilter === filter_1;
      $[16] = activeFilter;
      $[17] = t11;
    } else {
      t11 = $[17];
    }
    const isActive = t11;
    t10 = "tw-w-full tw-pb-2 tw-pt-2 lg:tw-pt-4";
    t6 = containerRef;
    t7 = "tw-nowrap tw-relative tw-flex tw-h-10 tw-items-center tw-gap-1 tw-overflow-x-auto tw-rounded-lg tw-border tw-border-solid tw-border-iron-800 tw-bg-iron-950";
    if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
      t8 = <div ref={highlightRef} className="tw-absolute tw-h-8 tw-rounded-lg tw-bg-iron-800 tw-transition-all tw-duration-300 tw-ease-in-out" />;
      $[18] = t8;
    } else {
      t8 = $[18];
    }
    t9 = NotificationFilters.map((filter_2, index) => <NotificationCauseFilterButton key={`notification-cause-filter-${filter_2.title}`} title={filter_2.title} isActive={isActive(filter_2)} onClick={() => handleChange(filter_2, index)} onMouseEnter={() => handleHover(filter_2)} buttonRef={el => buttonRefs.current[index] = el} />);
    $[8] = activeFilter;
    $[9] = handleHover;
    $[10] = setActiveFilter;
    $[11] = t10;
    $[12] = t6;
    $[13] = t7;
    $[14] = t8;
    $[15] = t9;
  } else {
    t10 = $[11];
    t6 = $[12];
    t7 = $[13];
    t8 = $[14];
    t9 = $[15];
  }
  let t11;
  if ($[19] !== t6 || $[20] !== t7 || $[21] !== t8 || $[22] !== t9) {
    t11 = <div ref={t6} className={t7}>{t8}{t9}</div>;
    $[19] = t6;
    $[20] = t7;
    $[21] = t8;
    $[22] = t9;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== t10 || $[25] !== t11) {
    t12 = <div className={t10}>{t11}</div>;
    $[24] = t10;
    $[25] = t11;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  return t12;
}
function NotificationCauseFilterButton(t0) {
  const $ = _c(10);
  const {
    title,
    isActive,
    onClick,
    onMouseEnter,
    buttonRef
  } = t0;
  let t1;
  if ($[0] !== isActive) {
    t1 = () => `tw-border-none tw-bg-transparent tw-no-underline tw-flex tw-justify-center tw-items-center
     tw-px-3 tw-py-2 tw-gap-2 tw-flex-1 tw-h-8 tw-rounded-lg tw-transition-colors tw-duration-300
     tw-ease-in-out tw-relative z-10 ${isActive ? "tw-text-iron-300" : "tw-text-iron-400 desktop-hover:hover:tw-text-iron-300"}`;
    $[0] = isActive;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const getLinkClasses = t1;
  const t2 = getLinkClasses();
  let t3;
  if ($[2] !== title) {
    t3 = <span className="tw-text-sm tw-font-semibold">{title}</span>;
    $[2] = title;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== buttonRef || $[5] !== onClick || $[6] !== onMouseEnter || $[7] !== t2 || $[8] !== t3) {
    t4 = <button className={t2} onClick={onClick} onMouseEnter={onMouseEnter} ref={buttonRef}>{t3}</button>;
    $[4] = buttonRef;
    $[5] = onClick;
    $[6] = onMouseEnter;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
}